"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 */
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_tooltip_settings_component_1 = require("./sis-tooltip-settings.component");
/**
 * @deprecated - use BaseSettings from ng-controls
 */
var SisControlWithTooltipSettings = /** @class */ (function () {
    function SisControlWithTooltipSettings(_communicationService) {
        this._communicationService = _communicationService;
    }
    Object.defineProperty(SisControlWithTooltipSettings.prototype, "tooltipSettings", {
        get: function () {
            return this._tooltipSettings;
        },
        set: function (settings) {
            this._tooltipSettings = settings;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    tooltipSettings: this._tooltipSettings.toJsonString(),
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", sis_tooltip_settings_component_1.TooltipSettings),
        __metadata("design:paramtypes", [sis_tooltip_settings_component_1.TooltipSettings])
    ], SisControlWithTooltipSettings.prototype, "tooltipSettings", null);
    return SisControlWithTooltipSettings;
}());
exports.SisControlWithTooltipSettings = SisControlWithTooltipSettings;
//# sourceMappingURL=sis-control-with-tooltip-settings.js.map